// extracted by mini-css-extract-plugin
export default {"header":"AppHeader_header__zjwzz","headerWrapper":"AppHeader_headerWrapper__GAj1n","content":"AppHeader_content__4XJ0w"};